import { useMemo } from "react";
import { useGlobalFilter, usePagination, useSortBy, useTable, useRowSelect } from "react-table";
import { Row, Table } from "react-bootstrap";

import DetailTable from "./DetailTable";
import { ReactComponent as TableArrowUpIcon } from "@/assets/images/icons/Table/up-arrow.svg";
import { ReactComponent as TableArrowDownIcon } from "@/assets/images/icons/Table/down-arrow.svg";

import classes from "./reactTable.module.scss";

const CustomTable = ({ COLUMNS, data, hiddenColumns, onRowSelect: _onRowSelect = () => {}, detailColumns = [], base, setBase, colorBackground = true }) => {
	const setAllOrder = (order, orderType) => {
		setBase({ ...base, order: order, orderType: orderType });
	};

	const handleArrowUp = (column) => {
		if (setAllOrder) {
			setAllOrder(column.id, "asc");
			return;
		}
	};

	const handleArrowDown = (column) => {
		if (setAllOrder) {
			setAllOrder(column.id, "desc");
			return;
		}
	};

	// eslint-disable-next-line
	const columns = useMemo(() => COLUMNS, []);

	const tableInstance = useTable(
		{
			columns: columns,
			data,
			initialState: {
				hiddenColumns: hiddenColumns ? hiddenColumns : [],
				sortBy: [{ id: base.order, desc: base.orderType === "desc" }],
			},
		},
		useGlobalFilter,
		useSortBy,
		usePagination,
		useRowSelect,
	);

	const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;

	return (
		<Row className={classes.table}>
			<Table {...getTableProps()} className={classes.table_desktop}>
				<thead>
					{headerGroups.map((headerGroup) => {
						const { key: headerGroupKey, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
						return (
							<tr key={headerGroupKey} {...headerGroupProps}>
								{headerGroup.headers.map((column) => {
									const { key: columnKey, ...columnProps } = column.getHeaderProps();
									return (
										<th
											key={columnKey}
											{...columnProps}
											style={{
												width: `${column.size}%`,
												textAlign: "center",
												padding: "5px",
												borderTop: "0px",
												borderBottom: "0.5px solid #dee2e6",
												verticalAlign: "middle",
												position: "sticky",
												backgroundColor: "#fff",
												top: 0,
											}}
										>
											<div className={classes.label}>
												<div className={classes.textTitle}>{column.render("Header")}</div>

												{column.order ? (
													<div
														style={{
															width: "25%",
															display: "inline-flex",
															flexDirection: "column",
														}}
													>
														<div>
															<TableArrowUpIcon
																className={
																	column.isSorted && !column.isSortedDesc ? classes.iconArrowActive : classes.iconArrow
																}
																onClick={() => handleArrowUp(column)}
															/>
														</div>
														<div>
															<TableArrowDownIcon
																className={column.isSorted && column.isSortedDesc ? classes.iconArrowActive : classes.iconArrow}
																onClick={() => handleArrowDown(column)}
															/>
														</div>
													</div>
												) : (
													<div style={{ height: "21px" }}></div>
												)}
											</div>
										</th>
									);
								})}
							</tr>
						);
					})}
				</thead>
				<tbody {...getTableBodyProps()}>
					{rows.map((row) => {
						prepareRow(row);
						const { key: rowKey, ...rowProps } = row.getRowProps();
						return [
							<tr key={rowKey} {...rowProps} className={`${classes.table_tr}`}>
								{row.cells.map((cell, index) => {
									const isMultiple = cell.column.isMultiple;
									const { key: cellKey, ...cellProps } = cell.getCellProps();

									return (
										<td
											key={cellKey}
											{...cellProps}
											className={`${classes.table_td} ${index === 0 ? classes.first_td : ""} ${
												!colorBackground && classes.no_background
											}`}
										>
											<div
												style={{ ...(cell.column.style ? { ...cell.column.style } : {}) }}
												className={`${classes.table_div} ${classes.long_text} ${isMultiple && classes.multiple} ${
													row.original.active ? classes.active : ""
												} ${classes.center}
													${index === 0 ? classes.first_div : index === row.cells.length - 1 ? classes.last_div : ""}
													${!colorBackground && classes.no_background}
												`}
											>
												{cell.render("Cell")}
											</div>
										</td>
									);
								})}
							</tr>,
							<DetailTable detailColumns={detailColumns} data={row.original} key={row.index} />,
						];
					})}
				</tbody>
			</Table>
		</Row>
	);
};

export default CustomTable;
